import { useMemo } from "react";

import { Select } from "@king-ict/eupisi-ui/components";
import { codeBookToSelectData } from "@king-ict/eupisi-ui/utils";
import { useTranslation } from "react-i18next";

import { ValidationFailure } from "../../models";
import { useGetSchoolYearCurrentAndNextQuery } from "../../queries/codeBookQuery";
import { CodeBook } from "@king-ict/eupisi-ui/models";

const TEMPORARY_EXEMPTION_SCHOOL_YEAR_PROPERTY =
  "TemporaryExemptionUntilSchoolYearId";

interface Props {
  value?: number;
  previouslySelectedSchoolYear?: CodeBook;
  schoolYearId?: number;
  isEditing: boolean;
  errors?: ValidationFailure[];
  onChange: (val?: number) => void;
}

export const TemporaryExemptionSchoolYearSelect = ({
  value,
  previouslySelectedSchoolYear,
  schoolYearId,
  isEditing,
  errors,
  onChange,
}: Props) => {
  const { t } = useTranslation();

  const { schoolYearsData } = useGetSchoolYearCurrentAndNextQuery(
    schoolYearId ?? 0,
    {
      skip: !schoolYearId || !isEditing,
      selectFromResult: ({ data }) => ({
        schoolYearsData: [data?.currentSchoolYear, data?.nextSchoolYear].filter(
          (schoolYear): schoolYear is CodeBook => !!schoolYear
        ),
      }),
    }
  );

  const errorText = useMemo(
    () =>
      errors?.find((e) =>
        e.propertyName?.startsWith(TEMPORARY_EXEMPTION_SCHOOL_YEAR_PROPERTY)
      )?.message,
    [errors]
  );

  const readonlySelectData = previouslySelectedSchoolYear
    ? [previouslySelectedSchoolYear]
    : [];

  const selectData = !isEditing ? readonlySelectData : schoolYearsData;

  const selectValue = !isEditing ? previouslySelectedSchoolYear?.id : value;

  return (
    <Select
      label={t("enrollmentDecision.temporaryExemptionUntilSchoolYear")}
      name="temporaryExemptionUntilSchoolYearId"
      value={selectValue}
      onChange={(e) =>
        onChange(
          e.target.value ? Number.parseInt(e.target.value, 10) : undefined
        )
      }
      selectData={codeBookToSelectData(selectData)}
      errorText={errorText}
      disabled={!isEditing}
    />
  );
};
